import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/emp-table-store';

const EmployeeTableContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default EmployeeTableContextWrapper;
